import styled from "styled-components";
import background from "../../assets/newImages/background/bg.png";

const ContainerAtualizarDadosCadastrais = styled.div`
  .bg-atualizar-dados {
    background-image:url(${background});
    background-size: cover;
    background-position: center;
    background-color: white;
    height: 100vh;
    width: 100vw;
    font-family: "Inter", sans-serif;
    margin: 0;
    padding: 0;

    .conteudo-atualizar {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }

    .card-atualizar {
      width: auto;
      height: auto;
      border: 1px solid #24844e;
      background-color: rgba(234, 234, 234, 0.4);
      border-radius: 32px;
      padding: 80px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 48px;

      .titulo-atualizar {
        color: #0d5229;
        text-align: center;
        font-size: 22px;
        line-height: 24px;
        font-weight: 700;
        margin: 0;
      }

      .logo-atualizar {
        height: 32px;
        width: auto;
      }

      .texto-complementar {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 8px;
        max-width: 420px;

        p,
        strong {
          color: #626262;
          text-align: center;
          font-size: 14px;
          line-height: 20px;
          font-weight: 400;
          margin: 0;
        }

        strong {
          font-weight: 700;
        }
      }

      .botao-atualizar {
        display: inline-block;
        padding: 14px 36px;
        border-radius: 999px;
        background-color: #0d5229;
        color: #ffffff;
        text-decoration: none;
        font-size: 14px;
        line-height: 20px;
        font-weight: 700;
        cursor: pointer;
        transition: opacity 0.2s ease;

        &:hover {
          opacity: 0.9;
        }
      }
    }
  }
`;

export { ContainerAtualizarDadosCadastrais };
